import React from 'react';

var MobileStructureTop = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: 'pgc-m-game-structure-top' }, children));
};

export { MobileStructureTop };
